import React, { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { useMatch } from 'react-router';
import TopBar from 'components/layout/topbar/topbar';
import RunsUsageBanner from 'components/layout/runs-usage-banner';
import NavBar from 'components/layout/navbar/navbar';

export const MainLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const isProjectRoute = Boolean(useMatch('/p/:projectId/*'));
  return (
    <OuterContainer>
      <RunsUsageBanner />
      <TopBar page={isProjectRoute ? '/p/:projectId/*' : '/*'} />
      <MainLayoutContainer>
        <NavBar />
        <ContentSlot>{children}</ContentSlot>
      </MainLayoutContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  max-height: 100%;
  overflow: hidden;
`;

const ContentSlot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryWhite};
  flex: 1;
  min-width: 0;
  max-height: 100%;
  overflow: hidden;
`;

export default MainLayout;
